import script from "./NavigationBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavigationBar.vue?vue&type=script&lang=ts&setup=true"

import "./NavigationBar.vue?vue&type=style&index=0&id=ff19e296&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff19e296"]])

export default __exports__